export default __webpack_public_path__ + "static/media/new-feature.58e648e3.svg";